import { render, staticRenderFns } from "./RegionMonitoring.vue?vue&type=template&id=772b5d2c&"
import script from "./RegionMonitoring.vue?vue&type=script&lang=js&"
export * from "./RegionMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports